module.exports = __webpack_public_path__ + "img/diaohua6.2f42f8eb.jpg";